import { PROMO_CODE_MAX_CHARS } from '../../constants';

const validatePromoCode = (promoCode) => {
  if (promoCode && promoCode.length > 0) {
    const isValid = promoCode.length <= PROMO_CODE_MAX_CHARS && /^[a-zA-Z0-9]+$/.test(promoCode);
    return !isValid;
  }
  return false;
};

export default validatePromoCode;
